import _ from "lodash";
import { Atgardstyp } from "~app/common/models/constants";
import { Atgard } from "../../models/atgard-models";
import { Kontrakt } from "../../models/kontrakt-models";
import { ErsattningsTyp, KontraktUtskriftValues } from "../../models/utskrift/utskriftValues-models";

const gallringTypes = [
    Atgardstyp.FrakAvv,
    Atgardstyp.GallringOspecificerad,
    Atgardstyp.Kvalitetsgallring,
    Atgardstyp.Laggallring,
    Atgardstyp.Hushallsgallring,
    Atgardstyp.Klengallring
];

const overstandareTypes = [
    Atgardstyp.UtglesningFS,
    Atgardstyp.AvvecklingFS
];

const ovrigAvverkningTypes = [
    Atgardstyp.Plockhuggning,
    Atgardstyp.Bladning,
    Atgardstyp.VindSkada,
    Atgardstyp.VagLedning,
    Atgardstyp.NSFrihuggning,
    Atgardstyp.NSLuckhuggning,
    Atgardstyp.NSRestavv,
    Atgardstyp.Kanthuggning,
    Atgardstyp.Luckhuggning,
    Atgardstyp.Grot,
    Atgardstyp.Energived,
    Atgardstyp.BiobransleLangsVag
];

const slutavverkningMedFrotradTypes = [
    Atgardstyp.ForyngringsavverkningTillFrotrad,
    Atgardstyp.ForyngringsavverkningTillSkarm
];

const slutavverkningUtanFrotradTypes = [Atgardstyp.Foryngringsavverkning];

export const setDefaultUtskriftValues = (values: KontraktUtskriftValues, kontrakt: Kontrakt, atgarder: Atgard[]) => {
    if(!hasKontraktGruppering(kontrakt)) {
        return;
    }

    const getArealSumByTypes = (types: string[]) => _.chain(atgarder)
        .filter(x => types.includes(x.atgardstyp))
        .sumBy(x => x.nettoareal)
        .round(1)
        .value();

    values.arealGallring = getArealSumByTypes(gallringTypes);
    values.arealOverstandare = getArealSumByTypes(overstandareTypes);
    values.arealOvrigAvverkning = getArealSumByTypes(ovrigAvverkningTypes);
    values.arealSlutavvMedFrotrad = getArealSumByTypes(slutavverkningMedFrotradTypes);
    values.arealSlutavvUtanFrotrad = getArealSumByTypes(slutavverkningUtanFrotradTypes);
    if (kontrakt.skordarmatning && values.ersattningstyp !== ErsattningsTyp.Bruttovolym) {
        values.ersattningstyp = ErsattningsTyp.Bruttovolym;
    }
};

export const hasKontraktGruppering = (kontrakt: Kontrakt) => kontrakt.isRundvirke
        && (kontrakt.isAffarsformU4
        || kontrakt.isAffarsformU5
        || kontrakt.isAffarsformU6);
